import { render, staticRenderFns } from "./CreatorPostLikes.vue?vue&type=template&id=051f6312&"
import script from "./CreatorPostLikes.vue?vue&type=script&lang=js&"
export * from "./CreatorPostLikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports